import { ErrorView } from "@/components/ui/layout/error/errorView"
import { cn } from "@/modules/lib/utils"
import { TemplateList } from "@/modules/template/components/sidebarImport/templateList"
import { TemplateListItem } from "@/modules/template/components/sidebarImport/templateListItem"
import { TemplateSearch } from "@/modules/template/components/sidebarImport/templateSearch"
import { useTemplateImportSelectedTemplate } from "@/modules/template/stores/useTemplateImportStore"
import { TemplateType } from "@/modules/template/types/templateType"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"

type TemplateWrapperProps = {
  templateType: TemplateType
  className?: string
} & React.ComponentProps<"div">

export function TemplateWrapper({ templateType, className, ...props }: TemplateWrapperProps) {
  const selectedTemplate = useTemplateImportSelectedTemplate()
  return (
    <div className={cn("flex flex-1 flex-col gap-3", className)} {...props}>
      <TemplateSearch templateType={templateType} className="px-6" />

      <div className="relative flex flex-1 flex-col">
        {selectedTemplate ? <TemplateListItem template={selectedTemplate} className="sticky top-0" /> : null}

        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <TemplateList templateType={templateType} />
          </Suspense>
        </ErrorBoundary>
      </div>
    </div>
  )
}
